
<app-sidebar></app-sidebar>
<app-mobile-header></app-mobile-header>

<div *ngIf="isTokenValid === null">
  <p>{{ 'registerSuccess.verifyingToken' | translate }}</p>
</div>
<div *ngIf="true">
  <div class="main-success">
    <div class="container">
      <div class="left-section">
        <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo hide-on-mobile">
        <h2>{{ 'registerSuccess.welcome' | translate }}</h2>
        <p>{{ 'registerSuccess.description' | translate }}</p>
        <button mat-raised-button color="primary" type="submit" (click)="continueRegister()" style = "margin-top: 20px;margin-right: 10px;">
          {{ 'registerSuccess.publishOffer' | translate }}
        </button>
        <button mat-raised-button color="primary" type="submit" (click)="goToCompass()" style = "margin-top: 20px;">
          {{ 'registerSuccess.compass' | translate }}
        </button>
      </div>
      <div class="right-section">
        <img src="/assets/11066756.jpg" alt="Success Illustration" class="illustration">
      </div>
    </div>
  </div>
</div>
<div *ngIf="isTokenValid === false && !loading">
  <div class="error-template">
    <div class="main-success">
        <div class="container">
          <div class="left-section">
            <img src="/assets/logo_2x.png" alt="Conectio Logo" class="logo">
            <h2 style = "color: red;">{{ 'registerSuccess.error' | translate }}</h2>
            <p>{{ 'registerSuccess.invalidLink' | translate }}</p>
          </div>
          <div class="right-section">
            <img src="/assets/error-token.webp" alt="Success Illustration" class="illustration" style = "border-radius: 40px;">
          </div>
        </div>
      </div>
  </div>
</div>